export default "__VITE_ASSET__Cr_rnLhu__"